import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { NakedButton, Text } from '@frontend/design-system';
import { historyItemStyle, historyListStyle, historyStyle } from './signature.styles';

interface SignatureHistoryListProps<T> {
  items: T[];
  getKey: (item: T) => string;
  /** Accessible name of the item's button (the thumbnail itself is decorative). */
  getLabel: (item: T) => string;
  renderItem: (item: T) => ReactNode;
  onSelect: (item: T) => void;
  disabled?: boolean;
}

/** "Select a previous e-signature" carousel of this session's signatures; renders nothing when empty. */
export const SignatureHistoryList = <T,>({
  items,
  getKey,
  getLabel,
  renderItem,
  onSelect,
  disabled,
}: SignatureHistoryListProps<T>) => {
  const { t } = useTranslation('digital-forms-experience');
  if (!items.length) return null;

  return (
    <div css={historyStyle}>
      <Text size='small' weight='bold'>
        {t('Select a previous e-signature to auto-fill.')}
      </Text>
      <ul css={historyListStyle}>
        {items.map((item) => (
          <li key={getKey(item)}>
            <NakedButton
              css={historyItemStyle}
              disabled={disabled}
              onClick={() => onSelect(item)}
              aria-label={getLabel(item)}
            >
              {renderItem(item)}
            </NakedButton>
          </li>
        ))}
      </ul>
    </div>
  );
};
